const entityName = 'tasks';

const taskModule = {
  state: {},
  mutations: {},
  actions: {
    fetchAll: (context) => {
      const url = entityName;
      return context.dispatch('getAllEntity', {url, entityName})
    },
    postTask: (context, task) => {
      const payload = {
        url: entityName,
        entityName: entityName,
        entity: task
      };
      return context.dispatch('postEntity', payload)
    },
    updateTask: (context, task) => {
      const payload = {
        url: entityName + '/' + task._id,
        entityName: entityName,
        entity: task
      };
      return context.dispatch('putEntity', payload)
    },
    removeTask: (context, task) => {
      const payload = {
        url: entityName + '/' + task._id,
        entityName: entityName,
        entity: task
      };
      return context.dispatch('deleteEntity', payload)
    },
  },
  getters: {}
};

export default taskModule;
